import React, { useEffect, useState } from 'react';
import prevIcon from '../../../Constant/Icons/leftarrow.svg';
import nextIcon from '../../../Constant/Icons/rightarrow.svg';
import SerachBar from './SerachBar';
import { serverUrl } from '../../../Constant/Static/config';
import axios from 'axios';

function RankList() {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [searchVal, setSearchVal] = useState("");
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      // console.log("page ", pageSize);

      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          `${ serverUrl }/api/admin/rank/records?page = ${ page }&pageSize=${ pageSize }`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const result = await response.json();
          // console.log(result.data);

          setData(result.data);
          setTotalPages(result.totalPages);
        } else {
          throw new Error("Received non-JSON response");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchSearchData = async () => {
      // console.log("search", searchVal);

      setLoading(true);
      setError(null);
      try {
        const response = await axios.post(
          `${ serverUrl }/api/admin/rank/searchRecords`,
          {
            searchVal,
          }
        );
        // if (!response.ok) {
        //   throw new Error('Network response was not ok');
        // }
        // const contentType = response.headers.get("content-type");
        if (response.status == 200) {
          // const result = await response.json();
          // console.log(response.data.result);

          setData(response.data.result);
          setTotalPages(1);
        } else {
          throw new Error("Unsuccessful request");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    if (searchVal != null && searchVal != "") {
      fetchSearchData();
    } else if (pageSize > 0) {
      fetchData();
    }
  }, [page, pageSize, searchVal]);
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  return (
    <>
      <SerachBar onDebouncing={setSearchVal} />
      <div className='student-table-wrapper'>
        <div className='student-table-container'>
          {error && <div>Error: {error}</div>}
          <table className='student-responsive-table'>
            <thead>
              <tr>
                <th>S No.</th>
                <th>Application No.</th>
                <th>Applicant Name</th>
                <th>University Reg No.</th>
                <th>Sex</th>
                <th>DOB</th>
                <th>Community</th>
                <th>SEM1_MAX</th>
                <th>SEM1_OBT</th>
                <th>SEM2_MAX</th>
                <th>SEM2_OBT</th>
                <th>SEM3_MAX</th>
                <th>SEM3_OBT</th>
                <th>SEM4_MAX</th>
                <th>SEM4_OBT</th>
                <th>SEM5_MAX</th>
                <th>SEM5_OBT</th>
                <th>SEM6_MAX</th>
                <th>SEM6_OBT</th>
                <th>SEM7_MAX</th>
                <th>SEM7_OBT</th>
                <th>SEM8_MAX</th>
                <th>SEM8_OBT</th>
                <th>PRESEM</th>
                <th>FINALSEM</th>
                <th>AVERAGE</th>
                <th>OCRANK</th>
                <th>COMM_RANK</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{row.APPLN_NO}</td>
                  <td>{row.NAME}</td>
                  <td>{row.UNIV_REG_NO}</td>
                  <td>{row.SEX}</td>
                  <td>{row.DOB}</td>
                  <td>{row.COMM}</td>
                  <td>{row.SEM1_MAX}</td>
                  <td>{row.SEM1_OBT}</td>
                  <td>{row.SEM2_MAX}</td>
                  <td>{row.SEM2_OBT}</td>
                  <td>{row.SEM3_MAX}</td>
                  <td>{row.SEM3_OBT}</td>
                  <td>{row.SEM4_MAX}</td>
                  <td>{row.SEM4_OBT}</td>
                  <td>{row.SEM5_MAX}</td>
                  <td>{row.SEM5_OBT}</td>
                  <td>{row.SEM6_MAX}</td>
                  <td>{row.SEM6_OBT}</td>
                  <td>{row.SEM7_MAX}</td>
                  <td>{row.SEM7_OBT}</td>
                  <td>{row.SEM8_MAX}</td>
                  <td>{row.SEM8_OBT}</td>
                  <td>{row.PRESEM}</td>
                  <td>{row.FINALSEM}</td>
                  <td>{row.AVERAGE}</td>
                  <td>{row.OCRANK}</td>
                  <td>{row.COMM_RANK}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {loading && <div>Loading...</div>}
        </div>
        <div className='pagination'>
          <button onClick={() => handlePageChange(page - 1)} disabled={page === 1 || loading}>
            <img src={prevIcon} width={15} height={15} alt="Back" />
          </button>
          <span>
            {page} of {totalPages}
          </span>
          <button onClick={() => handlePageChange(page + 1)} disabled={page === totalPages || loading}>
            <img src={nextIcon} width={15} height={15} alt="Next" />
          </button>
        </div>
      </div>
    </>
  );
}

export default RankList;